import { applyFilters, doRequest } from "./helpers";

export default class AddressService {
  static async getAddressesForModel(filters) {
    let path = "/address/for_model";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
